import './klarna';
import './ideal';
import './p24';
import './bancontact';
import './giropay';
import './eps';
import './multibanco';
import './sepa';
import './sofort';
import './wechat';
import './fpx';
import './becs';
import './grabpay';
import './alipay'
import './afterpay';
import './boleto';
import './oxxo';
import './affirm';
import './blik';
import './konbini';
import './paynow';